<template>
    <div class="flex">
        <button
            class="
                flex items-center px-6 py-3 border border-transparent
                rounded-md font-semibold text-xs text-white tracking-widest
                hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900
                focus:shadow-outline-gray transition ease-in-out duration-150
            "
            :class="this.$page.props.currentRouteName === 'trade.index' ? `bg-gray-300` : `bg-gray-800`"
            @click="showModal('trade')"
        >
            <i class="fas fa-coins mr-3 text-md"/>
            Ordens
        </button>

        <button
            class="
                flex items-center px-6 py-3 border border-transparent
                rounded-md font-semibold text-xs text-white tracking-widest
                hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900
                focus:shadow-outline-gray transition ease-in-out duration-150
                ml-4
            "
            :class="this.$page.props.currentRouteName === 'buy.index' ? `bg-gray-300` : `bg-gray-800`"
            @click="showModal('buy')"
        >
            <i class="fas fa-shopping-cart mr-3 text-md"/>
            Comprar
        </button>

        <inertia-link
            class="
                flex items-center px-6 py-3 border border-transparent
                rounded-md font-semibold text-xs text-white tracking-widest
                hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900
                focus:shadow-outline-gray transition ease-in-out duration-150
                ml-4
            "
            :class="this.$page.props.currentRouteName === 'withdraw.index' ? `bg-gray-300` : `bg-gray-800`"
            :href="route('withdraw.index')"
        >
            <i class="fas fa-hand-holding-usd mr-3 text-md"/>
            Saques
        </inertia-link>

        <inertia-link
            class="
                flex items-center px-6 py-3 border border-transparent
                rounded-md font-semibold text-xs text-white tracking-widest
                hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900
                focus:shadow-outline-gray transition ease-in-out duration-150
                ml-4
            "
            :class="this.$page.props.currentRouteName === 'wallet.index' ? `bg-gray-300` : `bg-gray-800`"
            :href="route('wallet.index')"
        >
            <i class="fas fa-wallet mr-3 text-md"/>
            Wallets
        </inertia-link>

        <ConfirmationModal :show="showConfirmation" @close="showConfirmation=false">
            <template #title>
                <div class="ml-2">Para continuar é necessário a confirmação dos termos.</div>
            </template>
            <template #content>
                <div class="flex flex-row items-center">
                    <input
                        class="appearance-none text-center text-white h-5 w-5 border-2 border-gray-400 rounded checked:bg-blue-400 checked:border-transparent fas fa-check mx-2 mt-4"
                        type="checkbox"
                        name="termsAccept"
                        v-model="form.accepted_crypto_terms"
                    />
                    <div>
                        <div class="text-sm mt-4">
                            Leia os
                            <a :href="route('termsCrypto.index')" target="_blank" class="text-blue-500">
                                termos de uso desta plataforma de compra e venda de cripto
                            </a>
                            no link destacado
                        </div>

                        <p class="text-gray-500">
                            Li e concordo com os termos de uso desta plataforma de
                            compra e venda de cripto
                        </p>
                    </div>
                </div>
            </template>
            <template #footer>
                <button @click="acceptTerms"
                        :disabled="!form.accepted_crypto_terms"
                        class="px-4 py-2  text-sm font-medium  focus:outline-none  rounded-lg border border-gray-200 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:border-gray-600 w-52 disabled:cursor-not-allowed"
                        :class="form.accepted_crypto_terms ? ' bg-green-500 text-white' : 'bg-green-200 text-gray-400 cursor-not-allowed'"
                >
                    Continuar
                </button>
                <SecondaryButton @click.native="showConfirmation = false">
                    Cancelar
                </SecondaryButton>
            </template>
        </ConfirmationModal>
    </div>
</template>
<script>
import ConfirmationModal from '../../Jetstream/ConfirmationModal.vue'
import SecondaryButton from '../../Jetstream/SecondaryButton.vue'
import OkButton from '../../Jetstream/SecondaryButton.vue'
import OtcBalance from "../../Helpers/OtcBalance";

export default {
    data() {
        return {
            showConfirmation: false,
            typeRoute: '',
            form: this.$inertia.form({
                _method: 'POST',
                accepted_crypto_terms: false,
                routeRedirect: null
            })
        }
    },
    methods: {
        async acceptTerms() {
            this.form.routeRedirect = this.typeRoute
            this.form.post('/accept-terms-crypto', {
                onError: () => {

                }
            })
        },
        showModal(type) {
            if (!this.$page.props.activeAccount.accepted_crypto_terms) {
                this.showConfirmation = true;
                this.typeRoute = type
                return
            }
            this.$inertia.get(this.route(`${type}.index`))

        }
    },
    components: {
        OtcBalance,
        ConfirmationModal,
        SecondaryButton,
        OkButton
    },

}
</script>
